import { FamilyHistory } from "../../../../../../../services";
import { createMapper } from "../../../../../../../utils/utils";
import * as Yup from "yup";

// `problems` is a form-only field (AsyncSelect option) that gets mapped into
// the API payload; it is not part of the generated FamilyHistory model.
export type FamilyHistoryForm = FamilyHistory & {
  problems?: { uuid: string; name: string };
};

export const FAMILY_INITIAL_VALUES: FamilyHistoryForm = {
  conditionName: undefined,
  relative: undefined,
};

export const FAMILY_VALIDATION_SCHEMA = Yup.object().shape({
  conditionName: Yup.string().required().label("Condition Name"),
  relative: Yup.string().required().label("Relative"),
});

export const SURGERY_INITIAL_VALUES = {
  surgeryName: undefined,
  surgeryDate: new Date()?.toISOString(),
};

export const SURGERY_VALIDATION_SCHEMA = Yup.object().shape({
  surgeryName: Yup.string().required().label("Surgery Name"),
  // surgeryDate: Yup.string().required().label("Date"),
});

export const RELATIVE_LIST = [
  { label: "Self", value: "SELF" },
  { label: "Spouse", value: "SPOUSE" },
  { label: "Other", value: "OTHER" },
  { label: "Child", value: "CHILD" },
  { label: "Employer", value: "EMPLOYER" },
  { label: "Father", value: "FATHER" },
  { label: "Mother", value: "MOTHER" },
  { label: "Parent", value: "PARENT" },
  { label: "Grandparent", value: "GRANDPARENT" },
  { label: "Sibling", value: "SIBLING" },
  { label: "Unknown", value: "UNKNOWN" },
  { label: "Grandchild", value: "GRANDCHILD" },
  { label: "Guardian", value: "GUARDIAN" },
];

export const RELATIVE_MAPPER = createMapper(RELATIVE_LIST);

export const DIED_LIST = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const SOCIAL_HISTORY_QUESTION_TYPES = [
  { label: "Home And Environment", value: "HOME_AND_ENVIRONMENT" },
  { label: "Substance Use", value: "SUBSTANCE_USE" },
  { label: "Education And Occupation", value: "EDUCATION_AND_OCCUPATION" },
  { label: "Lifestyle", value: "LIFESTYLE" },
  { label: "Marriage And Sexuality", value: "MARRIAGE_AND_SEXUALITY" },
  { label: "Advance Directive", value: "ADVANCE_DIRECTIVE" },
  { label: "Diet And Exercise", value: "DIET_AND_EXERCISE" },
  { label: "Public Health And Travel", value: "PUBLIC_HEALTH_AND_TRAVEL" },
  { label: "Activities Of Daily Living", value: "ACTIVITIES_OF_DAILY_LIVING" },
  { label: "Covid 19 Vaccine Screening", value: "COVID_19_VACCINE_SCREENING" },
  // { label: "Migration From 123121", value: "MIGRATION_FROM_123121" },
  { label: "Psychiatry", value: "PSYCHIATRY" },
];

export const SOCIAL_HISTORY_QUESTION_ENUM_LIST = [
  "HOME_AND_ENVIRONMENT",
  "SUBSTANCE_USE",
  "EDUCATION_AND_OCCUPATION",
  "LIFESTYLE",
  "MARRIAGE_AND_SEXUALITY",
  "ADVANCE_DIRECTIVE",
  "DIET_AND_EXERCISE",
  "PUBLIC_HEALTH_AND_TRAVEL",
  "ACTIVITIES_OF_DAILY_LIVING",
  "COVID_19_VACCINE_SCREENING",
  // "MIGRATION_FROM_123121",
  "PSYCHIATRY",
];

export const SOCIAL_HISTORY_QUESTION_TYPES_MAPPER = createMapper(
  SOCIAL_HISTORY_QUESTION_TYPES
);
